import React, { Component } from 'react';
import FX from './functions/functions';
import './css/SearchBox.css';
//import logo from './logo.svg';
class SearchBox extends Component {
    constructor(props) {
      super(props);
      this.state = {selected:0, show: [1], list: [], searchText:'', loading:false};
      this.capture = this.capture.bind(this);
      this.selectItem = this.selectItem.bind(this);
      this.selectedTop = this.selectedTop.bind(this);
      this.handleST = this.handleST.bind(this);
      this.runSearch = this.runSearch.bind(this);
      this.onSearchInput = this.onSearchInput.bind(this);
      this.focus = this.focus.bind(this);
      this.searchSeq = 0;       // latest-request-wins sequence
      this.searchTimer = null;  // debounce handle
    }
		componentWillUpdate(nextProps, nextState){
		  if (this.state.searchText !== nextState.searchText){
		    if(document.getElementById('prodListPopup')){
		       document.getElementById('prodListPopup').scrollTop = 0;
		    }
		  }
		}
		componentDidUpdate(prevProps, prevState){
		  // NOTE: the remote search is driven directly from the input's onChange
		  // (onSearchInput), NOT from a prevState/state diff here. FX.formHandler
		  // mutates this.state IN PLACE before setState, so prevState === this.state
		  // and any "searchText changed?" comparison in this lifecycle is always
		  // false — which is why the editor search previously made no request.
		  if(!!this.state.searchText){
		  this.focus();
		  document.getElementById("prod_search").value = document.getElementById("prod_search").value;
      }
		}
		componentWillUnmount(){
		  // Cancel any pending debounce and invalidate in-flight responses so we
		  // never setState after the component has unmounted.
		  if(this.searchTimer){ clearTimeout(this.searchTimer); }
		  this.searchSeq++;
		}
		focus(){
		  if(!!this.state.searchText){
		     setTimeout(() => {
		        if(document.getElementById("prod_search")){
		        document.getElementById("prod_search").focus();
            document.getElementById("prod_search").setSelectionRange(document.getElementById("prod_search").value.length, document.getElementById("prod_search").value.length);
		      }
		     }, 20);
      }
		}
		runSearch(searchText){
		  if(this.searchTimer){ clearTimeout(this.searchTimer); }
		  if(!searchText){
		    this.searchSeq++;            // invalidate any in-flight request
		    this.setState({list: [], selected: 0, loading: false});
		    return;
		  }
		  // Mark as loading so the popup shows a "Searching..." state instead of
		  // flashing the "no matching items" empty-state during the async fetch.
		  this.setState({loading: true});
		  this.searchTimer = setTimeout(() => {
		    var seq = ++this.searchSeq;
		    // encodeQueryData does not encode values; encode the free-text term so
		    // SKUs/names with &, +, #, % etc. don't corrupt the query string.
		    var data = {customer_id: this.props.root.state.customer_id, search: encodeURIComponent(searchText), limit: 20, page: 1};
		    var qs = FX.encodeQueryData(data, true);
		    FX.load(this.props.root, 'product_paged' + qs, (res) => {
		      if(seq !== this.searchSeq){ return; }   // a newer keystroke superseded this
		      var prods = (res.products || []).filter(prod =>
		        parseInt(prod.ignore, 10) !== 1 &&
		        (!prod.composite || this.props.showComposite === true) &&
		        (this.state.show.indexOf(parseInt(prod.status, 10)) !== -1)
		      );
		      if(!prods.length){
		        var audio = new Audio('/media/break.mp3');
		        audio.play();
		      }
		      this.setState({list: prods, selected: 0, loading: false});
		    });
		  }, 250);
		}
		onSearchInput(e){
		  // Update the controlled input and kick off the (debounced) remote search
		  // in one place. We do NOT rely on a componentDidUpdate state-diff to fire
		  // the search, because FX.formHandler mutates state in place (see note in
		  // componentDidUpdate) and that comparison can never detect the change.
		  var v = e.target.value;
		  this.setState({searchText: v});
		  this.runSearch(v);
		}
		handler = (tgt, e) => {
		}
		capture(e){
          var pl = this.state.list;
          switch(e.keyCode){
            case 13:
              if(this.state.list[this.state.selected]){
                this.selectItem.bind(null, this.state.list[this.state.selected])();
              }
              e.preventDefault();
              e.stopPropagation()
              break;
            case 27:
              this.props.root.setState({searchText:''});
              if (document.getElementById("searchBox"))
		              document.getElementById("searchBox").focus();
              e.preventDefault();
              e.stopPropagation()
              break;
            case 33:
              this.setState({selected:0});
                this.selectedTop(0);
                e.preventDefault();
                e.stopPropagation()
              break;
            case 34:
                this.setState({selected:pl.length-1});
                this.selectedTop(pl.length-1);
                e.preventDefault();
                e.stopPropagation()
              break;
            case 38:
              if(this.state.selected > 0){
              this.setState({selected:this.state.selected-1});
              this.selectedTop(this.state.selected-1);
              }
              else if (this.state.selected !== 0) {
              this.setState({selected:0});
              }
              e.preventDefault();
              e.stopPropagation()
              break;
            case 40:
              if(this.state.selected < pl.length-1){
                this.setState({selected:this.state.selected+1});
                this.selectedTop(this.state.selected+1);
              }
              else if (this.state.selected !== pl.length-1) {
                this.setState({selected:pl.length-1});
              }
          e.preventDefault();
              e.stopPropagation();
              break;
            default:
          }
		}
		selectedTop(sel){
		  if(document.getElementById('id_' + sel)){
		      if(document.getElementById('id_' + sel).offsetTop < document.getElementById('prodListPopup').scrollTop){
		         document.getElementById('prodListPopup').scrollTop = document.getElementById('id_' + sel).offsetTop  - 20;

		      }

		      if((document.getElementById('prodListPopup').scrollTop + document.getElementById('prodListPopup').offsetHeight) < (document.getElementById('id_' + sel).offsetTop + document.getElementById('id_' + sel).offsetHeight)){
		     document.getElementById('prodListPopup').scrollTop = ((document.getElementById('id_' + sel).offsetTop +
		                                                              document.getElementById('id_' + sel).offsetHeight) -
		                                                              document.getElementById('prodListPopup').offsetHeight) + 20;
		      }
		  }
		   //console.log(document.getElementById('id_' + sel).offsetTop + document.getElementById('id_' + sel).offsetHeight );
       //document.getElementById('prodListPopup').scrollTop = 0;
		}
		handleST(e){
      this.setState({searchText:e.target.value});
		}
		selectItem(prod){
		  this.props.parent.selectProduct.bind(null,prod)();
      this.setState({searchText:'', selected:0});
		}
    render() {
        var i = 0;

		    if(!this.props.root.state.current_customer || !this.props.root.state.current_customer.products ){
		      return '';
		    }

		    if(!!this.state.searchText){
		      if(this.props.root.autoKey != this.capture ){
		        this.park = this.props.root.autoKey;
		      }
		      this.props.root.autoKey = this.capture;
          // Show a neutral "Searching..." row while a request is in flight so we
          // don't flash the "no matching items" empty-state before results land.
          var tbo = this.state.loading
            ? <tr><td><div style={{background:'#fff', fontSize: '20px', padding: '20px', borderBottom: 'solid 4px #07a', textAlign: 'center', boxShadow:'2px 2px 3px rgba(0,0,0,0.2)'}}>Searching...</div></td></tr>
            : <tr><td><div style={{background:'#fff', fontSize: '20px', padding: '20px', borderBottom: 'solid 4px #07a', textAlign: 'center', boxShadow:'2px 2px 3px rgba(0,0,0,0.2)'}}>Sorry... Can't find any matching Items</div></td></tr>
		      if(this.state.list.length){
		        tbo = this.state.list.map(( prod ) => {
		            if(!prod.composite || this.props.showComposite === true){
                   var cl = '';
                   if(i == this.state.selected){
                     cl = 'selected';
                   }
                   var _id = 'id_' + i.toString();
                   i++;
                   var stock;
                   if(prod.stock_alloc && this.props.showAllocated === true){
                     stock = <span title="Stock Level: Brackets denote stock after fulfilling all outstanding and unpacked orders." className="stockCount">{prod.stock} ({prod.stock-prod.stock_alloc}) </span>
                   }
                   else {
                     stock = <span title="Stock Level" className="stockCount">{prod.stock}</span>
                   }
                   return <tr className={cl} id={_id} key={_id} onClick={this.selectItem.bind(null, prod)}><td title="SKU (Stock Keeping Unit)">{prod.sku}</td><td title="Product Name">{prod.name}</td><td>{stock}</td></tr>
                }
            });
          }
          return (
            <div>
              <input id="prod_search" value={this.state.searchText} onChange={this.onSearchInput}/>
              <div id="prodListPopup" className="prodListPopup"   onClick={(e) => {console.log(e); e.stopPropagation(); e.preventDefault(); this.setState({searchText:''})}} >
              <button className="closePopup" onClick={() => {this.setState({searchText:''})}}>X</button>
              <table id="product_list">
                <tbody>
                  {tbo}
                </tbody>
              </table>
              </div>
            </div>
          )
        }
        else {
          if(this.park && this.props.root.autoKey !== this.park){
		        this.props.root.autoKey = this.park;
		        console.log(this.park);
		      }
        }
        return (
          <div>
            <input id="prod_search" placeholder="Product Search" value={this.state.searchText} onChange={this.onSearchInput}/>
          </div>
        );
    }
	}
export default SearchBox;



// WEBPACK FOOTER //
// ./src/SearchBox.js